<div
  (click)="$event.stopPropagation(); $event.preventDefault()"
  style="
    cursor: default;
    height: fit-content;
    background-color: 'transparent';
    display: contents;
    overflow: hidden;
  "
>
  <div class="vertical-flex wrapper">
    <div
      class="horizontal-flex sort"
      [class.active]="currentSort == sortEnum.DESCENDING"
    >
      <button mat-stroked-button class="AZ-button" (click)="setSort(false)">
        <p style="margin-left: -10px; line-height: 28px">
          AZ
          <mat-icon
            style="
              transform: rotate(90deg) translateX(-2px);
              margin-left: -14px;
              font-size: 15px;
            "
            >arrow_right_alt</mat-icon
          >
        </p>
      </button>
      <p class="AZ-text">Sort A-Z</p>
    </div>
    <div
      class="horizontal-flex sort"
      [class.active]="currentSort == sortEnum.ASCENDING"
    >
      <button mat-stroked-button class="AZ-button" (click)="setSort(true)">
        <p style="margin-left: -10px; line-height: 28px">
          AZ
          <mat-icon
            style="
              transform: rotate(-90deg) translateX(3px);
              margin-left: -4px;
              font-size: 14px;
            "
            >arrow_right_alt</mat-icon
          >
        </p>
      </button>
      <p class="AZ-text">Sort Z-A</p>
    </div>
    <mat-divider style="margin: 5px"></mat-divider>
    <div class="searchBar" *ngIf="canSearch">
      <input
        type="text"
        size="16"
        placeholder="Search"
        [(ngModel)]="searchFilter"
        (keyup.enter)="filterCurrentSelection(true)"
      />
      <button
        class="AZ-button"
        (click)="filterCurrentSelection(true)"
        mat-stroked-button
        color="secundary"
      >
        <mat-icon class="searchIcon">search</mat-icon>
      </button>
    </div>
    <div class="filter-values">
      <div class="clickable" (click)="allSelected = !allSelected">
        <p-checkbox [ngModel]="allSelected" [binary]="true"></p-checkbox>
        <span class="filter-value">(Select all)</span>
      </div>
      <div
        class="clickable"
        *ngIf="searchFilter"
        (click)="filterCurrentSelection()"
      >
        <p-checkbox
          [ngModel]="currentFilteredSelection"
          [binary]="true"
        ></p-checkbox>
        <span class="filter-value">(Filter current selection)</span>
      </div>
      <ng-container *ngFor="let item of filteredValues">
        <div
          *ngIf="item != undefined"
          class="clickable"
          (click)="toggleValue(item)"
        >
          <p-checkbox [ngModel]="checkValue(item)" [binary]="true"></p-checkbox>
          <span class="filter-value">
            <ng-container
              *ngTemplateOutlet="template ?? default; context: { data: item }"
            ></ng-container>
          </span>
        </div>
      </ng-container>
      <div
        *ngIf="hasEmptyValue"
        class="clickable"
        (click)="toggleValue(undefined)"
      >
        <p-checkbox
          [ngModel]="checkValue(undefined)"
          [binary]="true"
        ></p-checkbox>
        <span class="filter-value">(Empty)</span>
      </div>
    </div>
    <div
      *ngIf="this.currentSort || this.selectedValues?.length"
      class="clear-filters"
      (click)="clearFilters()"
    >
      clear filter
    </div>
  </div>
</div>
<ng-template #default let-data="data">{{ data }}</ng-template>
